module.exports = __webpack_public_path__ + "img/AlertIcon.99ed18af.svg";